import { GenderLabelEnum } from './common.constant';
import { EXCEL_RESULT_MESSAGES } from './excel.constant';
import { RoutesNameEnum } from './router.constant';

export enum TextMessage {
	INTERNAL_SERVER_ERROR = 'Internal Server Error',
	INTERNET_NOT_WORKING = '네트워크 연결이 원활하지 않습니다.\n 잠시 후 다시 시도하세요.',
	EM001 = 'EM001',
	LOGIN_001 = '아이디 또는 비밀번호가 일치하지 않습니다.\n 아이디와 비밀번호를 정확히 입력해 주세요.',
	ERROR_MESSAGE_REQUIRED_FIELD = '필수항목 및 양식에 맞게 입력하여야 합니다.',
	OAUTH_001 = '해당 기능을 사용하실수 없습니다.',
	OAUTH_002 = '연동중에 오류가 발생하였습니다. 관리자에게 문의해주세요.',

	COMMON_INVALID_IP_ADDRESS = '등록된 허용 IP가 아니므로 접근할 수 없습니다.',
	// TODO: currently used COMMON_INVALID_IP_ADDRESS, update later
	// IP_ADDRESS_PERMISSION_DENIED = '등록된 허용 IP가 아니므로 접근할 수 없습니다.',

	ALERT_2 = 'ALERT_2',

	/** @description there are no selected documents to download */
	ALERT_3 = '다운로드 할 서류를 선택해주세요.',
	ALERT_4 = '일반 근로자, 동일한 공공형 사업자(농협) 각 각 따로 선택해야합니다.',
	/** @description there are no selected franchise */
	ALERT_5 = '사업장을 선택해주세요',

	/** @description verify file type */
	ALERT_6 = '양식에 맞지 않는 파일입니다. 입력 양식과 입력값을 확인해주세요.',

	ALERT_7 = 'ALERT_7',

	/** @description An error occurred. Please try again. */
	ALERT_8 = '오류가 발생했습니다. 다시 시도해주세요.',
	ALERT_9 = '업로드된 파일이 없습니다.',
	ALERT_10 = '이미 등록된 정보입니다.',

	/** @description verify email, ID */
	ALERT_11 = '이메일 중복 체크를 진행해주세요.',

	/** @description required field */
	ALERT_12 = '필수 항목을 입력해주세요.',

	/** @description incorrect format */
	ALERT_13 = '입력 양식에 맞게 입력해주세요.',

	/** @description You cannot register more than 5. */
	ALERT_15 = '5개 이상 등록할 수 없습니다.',

	/** @description There are no public franchise operators. Please register a public franchise operator in the business menu. */
	ALERT_19 = '공공형 사업자가 없습니다. 사업장 메뉴에서 공공형 사업자를 등록해주세요.',

	/** @description The written content will be reset/initialized */
	ALERT_20 = '작성한 내용이 초기화 됩니다.',

	/** @description There is no corresponding information. */
	ALERT_24 = '해당하는 정보가 없습니다.',

	/** @description save success */
	ALERT_31 = '저장에 성공하였습니다.',

	/** @description password confirm not match */
	ALERT_32 = '비밀번호가 일치하지 않습니다. 확인바랍니다.',

	/** @description The number of selected workers exceeds the requested number of workers. */
	ALERT_34 = '요청인원보다 많이 선택할 수 없습니다.',

	/** @description The number of workers is less than the required number for the assigned workplace. Do you want to proceed anyway? */
	CONFIRM_35 = '배정 사업장에 필요한 인원 수보다 근로자가 적습니다. 그대로 진행 하시겠습니까?',

	/** @description If you change workplace information, worker information not assigned to that workplace will be deleted. Do you still want to change it? */
	ALERT_36 = '사업장 정보를 변경하면 해당 사업장에 배정되지 않은 근로자 정보는 삭제 됩니다. 그래도 변경하시겠습니까?',

	/** @description password_confirm_required */
	ALERT_37 = '비밀번호 또는 비밀번호 확인을 입력해주세요.',

	/** @description Attachments cannot exceed 2MB. */
	ALERT_39 = '첨부파일은 2MB를 초과할 수 없습니다.',

	/** @description Confirm delete file */
	ALERT_44 = '등록된 파일을 삭제 하시겠습니까?',

	ALERT_51 = '10개 이상 선택할 수 없습니다.',

	/** @description Assignment is not possible during this period. */
	ALERT_52 = '해당기간에 배정이 불가능합니다.',

	/** @description Cannot select assignment. */
	ALERT_53 = '선택할 수 없는 배정내역입니다.',

	/** @description Invalid assignment. */
	ALERT_54 = '유효하지 않은 배정입니다.',

	/** @description Invalid franchise. */
	ALERT_55 = '해당 사업장을 선택할 수 없습니다.',

	/** @description The original work end date must be earlier than the new work start date. */
	ALERT_56 = '원 근무 종료일은 새 근무 시작일보다 작아야 합니다.',

	/** @description */
	ALERT_62 = '사업장의 읍/면 정보와 선택 된 근로자의 읍/면 정보가 다릅니다.',

	/** @description */
	ALERT_63 = '이미 배정된 정보가 존재하여 읍/면 정보를 변경할 수 없습니다.',

	/** @description */
	ALERT_64 = '존재하지 않는 정보입니다.',

	/** @description */
	ALERT_65 = '공공형 사업자(농협)의 읍/면 정보와 입력된 읍/면 정보가 다릅니다.',

	/** @description */
	ALERT_66 = '읍/면 값이 있는 관리자는 읍/면 정보가 동일한 관리자만 등록할 수 있습니다',

	/** @description  Please select one file.*/
	ALERT_68 = '한 개의 파일을 선택해 주세요.',

	/** @description */
	ALERT_69 = '전자문서에 입력되지 않은 항목이 있습니다. 그래도 다운로드하시겠습니까?.',

	/** @description  The value you have set is greater or less than the requested number of people.*/
	ALERT_70 = '요청 인원보다 설정한 값이 크커나 작습니다.',

	ALERT_70_PUBLIC = '입력하신 요청 인원보다 남/여 인원의 합이 맞지 않습니다. 그대로 적용하시겠습니까?',

	/** @description */
	ALERT_72 = '1개의 근로자만 선택해주세요.',

	ALERT_73 = '국내 사업체 또는 근로자가 수정한 근로자 정보는 삭제할 수 없습니다.',

	ALERT_75 = '관리자, 근로자, 사업장 정보 중, 이미 해당 공공형 사업자에 속한 정보가 존재하고 있어 변경할 수 없습니다',

	ALERT_76 = '체류자격의 코드와 기간을 먼저 선택해주세요.',

	ALERT_77 = '체류자격을 입력하지 않은 근로자가 있습니다. 체류자격을 입력해주세요.',

	/** @description */
	ALERT_79 = '입력한 조건에 맞춰 배정할 수 있는 근로자가 없습니다.',

	ALERT_80 = '읍/면 정보를 먼저 입력해주세요.',

	ALERT_81 = '읍/면 값을 변경하면, 공공형 사업자(농협) 값이 초기화됩니다.',

	ALERT_84 = '배정 이력이 없는 근로자 입니다. 배정 후 사용할 수 있습니다.',

	ALERT_85 = '자동 생성된 전자문서에 입력되지 않은 항목이 \n 있습니다. 그래도 다운로드하시겠습니까?',

	ALERT_87 = '이전 파일을 삭제하고 작성한 파일을 저장하시겠습니까?',

	ALERT_88_WORK_CHANGE = '배정 정보 등록 후 근무처 변경을 등록할 수 있습니다.',

	ALERT_88_UNAUTHORIZED = '배정 정보 등록 후 무단이탈을 등록할 수 있습니다.',

	ALERT_90 = '이미 한국 소속 정보로 등록 된, 정보가 있어 변경할 수 없습니다.',

	ALERT_92 = '직접 등록한 정보만 삭제할 수 있습니다.',

	ALERT_93 = '요청 인원 수보다 근로자 수가 더 많습니다.',

	COMMON_18 = '일부 파일이 업로드에 실패했습니다.',
	COMMON_INVALID_REQUEST = '잘못된 요청입니다.',

	DUPLICATE_EMAIL_DOMAIN = '이미 등록된 아이디 입니다.',
	AVAILABLE_EMAIL_DOMAIN = '사용 가능한 아이디 입니다.',
	AVAILABLE_DOMAIN = '사용 가능한 도메인 입니다.',
	VERIFY_DOMAIN = '도메인 중복 체크를 진행해주세요.',

	CONFIRM_5 = '이미 지난 입/출국일은 삭제됩니다. 상태를 변경 하시겠습니까?',

	CONFIRM_21 = '사이트에서 나가시겠습니까?\n변경사항이 저장되지 않을 수 있습니다.',
	CONFIRM_25 = '정말로 삭제하시겠습니까?',
	// CONFIRM_30 = '정말로 삭제하시겠습니까?' // use CONFIRM_25,

	DELETE_SUCCESS = '삭제되었습니다.',
	PASSWORD_NOT_VALID = '비밀번호: 영어, 숫자, 특수문자 포함 10자 이상, 동일문자 3자 이상, 연속문자 3자 이상, 전화번호 입력 불가',

	MP1_CURRENT_PASSWORD_INVALID = '기존 비밀번호가 일치하지 않습니다.',
	MP1_NEW_PASSWORD_INVALID = '이전에 사용하셨던 비밀번호 입니다. 새로운 비밀번호를 입력해주세요.',

	INCORRECT_FORMAT = '허용 확장자의 형식이 잘못되었습니다.',

	MAX_SIZE = '최대 20mb 파일만 업로드 가능합니다.',

	WC1_02_SELECT_DATE = '원 배정 정보를 먼저 선택해주세요',
	EM1_02_CHOOSE_APPLICANT = '근로자를 선택해주세요',
	EM1_02_CONFIRM_EXTENSION_STAY = '체류자격이 C-4이거나 상태가 근무중이 아닌 경우가 있습니다. 그래도 체류연장 등록하시겠습니까?',
	WC1_02_SELECT_WORKING_DATE = '원 근무 종료일을 입력해주세요.',
	TOAST_01 = '성공적으로 저장되었습니다.',

	CONFIRM_WHEN_SAVE_MY_PAGE = '저장되었습니다. 이전 화면으로 이동하시겠습니까?',
	CONFIRM_WHEN_EDIT_DATA = '수정된 내역이 있습니다. 그래도 페이지를 벗어나시겠습니까?',

	WORKER_ALREADY_SELECTED = '이미 선택한 근로자 입니다.',

	COMMON_NO_DOCUMENTS = '등록된 서류가 없습니다.',
	NO_SELECT_ASSIGNMENT = '배정 내역을 선택해주세요.',

	WARNING_WHEN_GO_TO_CREATE_UNAUTHORIZED_APPLICANT = '배정 정보를 먼저 해야 무단이탈을 등록할 수 있습니다.',
	WARNING_WHEN_GO_TO_CREATE_WORK_CHANGE = '배정 정보를 먼저 해야 근무처 변경을 등록할 수 있습니다.',
	WARNING_WHEN_GO_TO_CREATE_EXTENSION_STAY = '배정 정보를 먼저 해야 체류연장을 등록할 수 있습니다.',

	ALERT_FILE_SIZE_10MB = '첨부파일이 20Mb 이상이거나, 파일 형식을 확인해주세요.',

	PRIVACY_CONSENT_REQUIRED = '개인정보 수집 이용 및 제공 동의서 항목을 모두 동의하여야 서비스 이용이 가능합니다.',
	ALERT_LANDSCAPE_MODE = '새로 화면은 지원하지 않습니다.\n가로 화면으로 이용해주세요.',

	DISTRICT_MISMATCH = '근로자 읍/면이 변경되었습니다. 관련된 읍/면 관리자에게 안내해주세요.',

	AR_MID_TERM_DEPARTURE_DATE_IS_NULL = '출국일자를 먼저 입력해주세요.',
	AR_MID_TERM_DEPARTURE_DATE_IS_PAST = '출국일자를 먼저 미래 일자로 수정해주세요.',

	AM1_INVALID_RELAX_TIME = '근무 시간의 최소 휴게 시간보다 적어 휴게시간이 최소 휴게 시간으로 변경됩니다.',
}

export enum ServerMessageCode {
	ERR_NETWORK = 'ERR_NETWORK', // message: "Network Error"
	LOGIN_001 = 'LOGIN_001', // Username or password incorrect
	LOGIN_004 = 'LOGIN_004',
	OAUTH_001 = 'OAUTH_001', // Username or password incorrect
	OAUTH_002 = 'OAUTH_002', // Username or password incorrect
	CHANGE_PASSWORD_001 = 'CHANGE_PASSWORD_001', // Password does not match. Please re-enter.
	VISIT_DATE_OR_TIME_INVALID = 'VISIT_DATE_OR_TIME_INVALID',

	COMMON_INVALID_REQUEST = 'COMMON_INVALID_REQUEST',
	COMMON_EMAIL_DUPLICATE = 'COMMON_EMAIL_DUPLICATE',
	COMMON_PASSWORD_NOT_VALID = 'COMMON_PASSWORD_NOT_VALID',
	CM1_EXIST_DOMAIN = 'CM1_EXIST_DOMAIN',

	MP1_CURRENT_PASSWORD_INVALID = 'MP1_CURRENT_PASSWORD_INVALID',
	MP1_NEW_PASSWORD_INVALID = 'MP1_NEW_PASSWORD_INVALID',
	AM1_PROGRAM_NOT_FOUND = 'AM1_PROGRAM_NOT_FOUND',
	AR_INVALID_ASSIGNMENT_APPLICANT = 'AR_INVALID_ASSIGNMENT_APPLICANT',

	SYS_DUPLICATE_KEY = 'SYS_DUPLICATE_KEY',
	SYS_DATA_NOT_EXIST = 'SYS_DATA_NOT_EXIST',
	SYS_ID_HAS_DISTRICT_ID_NOT_VALID = 'SYS_ID_HAS_DISTRICT_ID_NOT_VALID',
	SYS_ID_HAS_PUBLIC_FRANCHISE_PUBLIC_NOT_MATCH = 'SYS_ID_HAS_PUBLIC_FRANCHISE_PUBLIC_NOT_MATCH',
	SYS_ID_RECORD_HAS_ASSIGN = 'SYS_ID_RECORD_HAS_ASSIGN',

	AM1_DUPLICATE_APPLICANT = 'AM1_DUPLICATE_APPLICANT',
	AM1_APPLICANT_NOT_POSSIBLE = 'AM1_APPLICANT_NOT_POSSIBLE',
	AM1_INVALID_FRANCHISE_ID = 'AM1_INVALID_FRANCHISE_ID',
	AM1_INVALID_DISTRICT_ID = 'AM1_INVALID_DISTRICT_ID',

	COMMON_UNAUTHORIZED = 'COMMON_UNAUTHORIZED',

	LM_DUPLICATE_ADDRESS = 'LM_DUPLICATE_ADDRESS',

	FRANCHISE_DUPLICATE = 'FRANCHISE_DUPLICATE',

	COMMON_PASSWORD_USED_BEFORE = 'COMMON_PASSWORD_USED_BEFORE',

	WC1_WORK_START_DATE_INVALID = 'WC1_WORK_START_DATE_INVALID',

	AM1_PUBLIC_FRANCHISE_HAS_CHANGED = 'AM1_PUBLIC_FRANCHISE_HAS_CHANGED',
	SYS_WC_ID_HAS_DISTRICT_ID_NOT_VALID = 'SYS_WC_ID_HAS_DISTRICT_ID_NOT_VALID',
	SYS_FRANCHISE_ID_IS_BEING_USED_CANNOT_CHANGE = 'SYS_FRANCHISE_ID_IS_BEING_USED_CANNOT_CHANGE',

	LM_DISTRICT_NOT_MAPPING = 'LM_DISTRICT_NOT_MAPPING',
	SYS_ID_LODGING_INVALID_DISTRICT = 'SYS_ID_LODGING_INVALID_DISTRICT',
	SYS_MANDATORY_INPUT_DISTRICT_FIRST = 'SYS_MANDATORY_INPUT_DISTRICT_FIRST',
	SYS_DATA_ALREADY_EXISTS = 'SYS_DATA_ALREADY_EXISTS',
	ERR_CANCELED = 'ERR_CANCELED',
	SYS_FOREIGN_EXIST_APPLICANT = 'SYS_FOREIGN_EXIST_APPLICANT',
	AR_CANNOT_DELETE_APPLICANT = 'AR_CANNOT_DELETE_APPLICANT',
	AR_APPLICANT_VISA_CODE_IS_C4 = 'AR_APPLICANT_VISA_CODE_IS_C4',
	AR_APPLICANT_NOT_HAVE_VISA_CODE = 'AR_APPLICANT_NOT_HAVE_VISA_CODE',
	AR_APPLICANT_VISA_CODE_IS_NULL = 'AR_APPLICANT_VISA_CODE_IS_NULL',
	AR_EXTENSION_PERIOD_OVER_8_MONTHS = 'AR_EXTENSION_PERIOD_OVER_8_MONTHS',
	CANNOT_DELETE_APPLICANT_USED = 'CANNOT_DELETE_APPLICANT_USED',
	OR_APPLICANT_HAS_USING_WITH_DOMESTIC_UNIT = 'OR_APPLICANT_HAS_USING_WITH_DOMESTIC_UNIT',
	SYS_PERMISSION_DENIED_DELETE = 'SYS_PERMISSION_DENIED_DELETE',
	AR_MID_TERM_DEPARTURE_DATE_IS_NULL = 'AR_MID_TERM_DEPARTURE_DATE_IS_NULL',
	AR_MID_TERM_DEPARTURE_DATE_IS_PAST = 'AR_MID_TERM_DEPARTURE_DATE_IS_PAST',

	AM1_INVALID_RELAX_TIME = 'AM1_INVALID_RELAX_TIME',
	AM1_ASSIGN_NUM_OVER_REQUEST_NUM = 'AM1_ASSIGN_NUM_OVER_REQUEST_NUM',

	COMMON_INVALID_IP_ADDRESS = 'COMMON_INVALID_IP_ADDRESS',
	IP_ADDRESS_PERMISSION_DENIED = 'IP_ADDRESS_PERMISSION_DENIED',

	SYS_DOMAIN_INVALID = 'SYS_DOMAIN_INVALID',
	SYS_DOMAIN_PERMISSION_DENIED = 'SYS_DOMAIN_PERMISSION_DENIED',
	SYS_DOMAIN_INACTIVE = 'SYS_DOMAIN_INACTIVE',

	SYSTEM_SESSION_EXTEND_LIMIT_EXCEEDED = 'SYSTEM_SESSION_EXTEND_LIMIT_EXCEEDED',
	DM_DEVICE_LIMIT_EXCEEDED = 'DM_DEVICE_LIMIT_EXCEEDED',

	DM_INVALID_CODE = 'DM_INVALID_CODE',
	DM_CODE_EXPIRED = 'DM_CODE_EXPIRED',
	DM_EXPIRED_CODE = 'DM_EXPIRED_CODE',
	DM_NOT_IN_OFFICE = 'DM_NOT_IN_OFFICE',
	DM_ACCOUNT_LOCKED = 'DM_ACCOUNT_LOCKED',
	DM_INVALID_STATUS = 'DM_INVALID_STATUS',
	DM_TOKEN_INVALID = 'DM_TOKEN_INVALID',
	DM_DEVICE_ACCESS_REVOKED = 'DM_DEVICE_ACCESS_REVOKED',
	DM_DUPLICATE_FINGERPRINT = 'DM_DUPLICATE_FINGERPRINT',

	// OTP error codes
	OTP_INVALID = 'OTP_INVALID',
	OTP_EXPIRED = 'OTP_EXPIRED',
	OTP_LOCKED = 'OTP_LOCKED',
	OTP_RESEND_TOO_EARLY = 'OTP_RESEND_TOO_EARLY',
	DM_TABLET_NAME_DUPLICATE = 'DM_TABLET_NAME_DUPLICATE',
}

export enum ErrorType {
	EM005 = 'EM005',
	EM006 = 'EM006',
	EM026 = 'EM026',
	EM024 = 'EM024',
	EM011 = 'EM011',
	EM013 = 'EM013',
	EM014 = 'EM014',
	EM015 = 'EM015',
	EM016 = 'EM016',
	EM017 = 'EM017',
	EM018 = 'EM018',
	EM012 = 'EM012',
	EM019 = 'EM019',
	EM034 = 'EM034',
}

export const ServerMessage = {
	[ServerMessageCode.ERR_NETWORK]: TextMessage.INTERNET_NOT_WORKING,
	[ServerMessageCode.LOGIN_001]: TextMessage.LOGIN_001,
	[ServerMessageCode.OAUTH_001]: TextMessage.OAUTH_001,
	[ServerMessageCode.OAUTH_002]: TextMessage.OAUTH_002,
	[ServerMessageCode.AR_INVALID_ASSIGNMENT_APPLICANT]: TextMessage.ALERT_4,
	[ServerMessageCode.COMMON_INVALID_REQUEST]:
		TextMessage.COMMON_INVALID_REQUEST,
	[ServerMessageCode.SYS_DUPLICATE_KEY]: TextMessage.ALERT_10,
	[ServerMessageCode.AM1_APPLICANT_NOT_POSSIBLE]: TextMessage.ALERT_52,
	[ServerMessageCode.AM1_INVALID_FRANCHISE_ID]: TextMessage.ALERT_55,
	[ServerMessageCode.AM1_INVALID_DISTRICT_ID]: TextMessage.ALERT_62,
	[ServerMessageCode.WC1_WORK_START_DATE_INVALID]: TextMessage.ALERT_52,
	[ServerMessageCode.FRANCHISE_DUPLICATE]: TextMessage.ALERT_10,
	[ServerMessageCode.COMMON_PASSWORD_USED_BEFORE]:
		TextMessage.MP1_NEW_PASSWORD_INVALID,
	[ServerMessageCode.SYS_DATA_NOT_EXIST]: TextMessage.ALERT_64,
	[ServerMessageCode.SYS_ID_HAS_DISTRICT_ID_NOT_VALID]:
		EXCEL_RESULT_MESSAGES.EXCEL_RESULT_LM_5,
	[ServerMessageCode.SYS_ID_HAS_PUBLIC_FRANCHISE_PUBLIC_NOT_MATCH]:
		TextMessage.ALERT_65,
	[ServerMessageCode.AM1_PUBLIC_FRANCHISE_HAS_CHANGED]: TextMessage.ALERT_54,
	[ServerMessageCode.SYS_ID_RECORD_HAS_ASSIGN]: TextMessage.ALERT_63,
	[ServerMessageCode.SYS_FRANCHISE_ID_IS_BEING_USED_CANNOT_CHANGE]:
		TextMessage.ALERT_75,
	[ServerMessageCode.LM_DISTRICT_NOT_MAPPING]:
		EXCEL_RESULT_MESSAGES.EXCEL_RESULT_LM_5,
	[ServerMessageCode.SYS_MANDATORY_INPUT_DISTRICT_FIRST]: TextMessage.ALERT_80,
	[ServerMessageCode.SYS_ID_LODGING_INVALID_DISTRICT]:
		EXCEL_RESULT_MESSAGES.EXCEL_RESULT_LM_5,
	[ServerMessageCode.AR_APPLICANT_VISA_CODE_IS_NULL]: TextMessage.ALERT_76,
	[ServerMessageCode.OR_APPLICANT_HAS_USING_WITH_DOMESTIC_UNIT]:
		TextMessage.ALERT_90,
	[ServerMessageCode.SYS_PERMISSION_DENIED_DELETE]: TextMessage.ALERT_92,
	[ServerMessageCode.AR_MID_TERM_DEPARTURE_DATE_IS_NULL]:
		TextMessage.AR_MID_TERM_DEPARTURE_DATE_IS_NULL,
	[ServerMessageCode.AR_MID_TERM_DEPARTURE_DATE_IS_PAST]:
		TextMessage.AR_MID_TERM_DEPARTURE_DATE_IS_PAST,
	[ServerMessageCode.COMMON_INVALID_IP_ADDRESS]:
		TextMessage.COMMON_INVALID_IP_ADDRESS,
	[ServerMessageCode.IP_ADDRESS_PERMISSION_DENIED]:
		TextMessage.COMMON_INVALID_IP_ADDRESS,
};

export const ShouldBackErrorList = [];

export const IgnoreMessageCodeInInterceptor: ServerMessageCode[] = [
	ServerMessageCode.CHANGE_PASSWORD_001,
	ServerMessageCode.MP1_CURRENT_PASSWORD_INVALID,
	ServerMessageCode.MP1_NEW_PASSWORD_INVALID,
	ServerMessageCode.COMMON_EMAIL_DUPLICATE,
	ServerMessageCode.COMMON_PASSWORD_NOT_VALID,
	ServerMessageCode.CM1_EXIST_DOMAIN,
	ServerMessageCode.AM1_PROGRAM_NOT_FOUND,
	ServerMessageCode.AM1_DUPLICATE_APPLICANT,
	ServerMessageCode.COMMON_UNAUTHORIZED,
	ServerMessageCode.ERR_CANCELED,
	ServerMessageCode.AR_CANNOT_DELETE_APPLICANT,
	ServerMessageCode.CANNOT_DELETE_APPLICANT_USED,
	ServerMessageCode.AR_APPLICANT_VISA_CODE_IS_C4,
	ServerMessageCode.AR_APPLICANT_NOT_HAVE_VISA_CODE,
	ServerMessageCode.AR_EXTENSION_PERIOD_OVER_8_MONTHS,
	ServerMessageCode.AM1_INVALID_RELAX_TIME,
	ServerMessageCode.SYSTEM_SESSION_EXTEND_LIMIT_EXCEEDED,
	ServerMessageCode.DM_INVALID_CODE,
	ServerMessageCode.DM_CODE_EXPIRED,
	ServerMessageCode.DM_EXPIRED_CODE,
	ServerMessageCode.DM_NOT_IN_OFFICE,
	ServerMessageCode.DM_ACCOUNT_LOCKED,
	ServerMessageCode.DM_INVALID_STATUS,
	ServerMessageCode.DM_TOKEN_INVALID,
	ServerMessageCode.DM_DEVICE_LIMIT_EXCEEDED,
	ServerMessageCode.DM_DUPLICATE_FINGERPRINT,
	// OTP error codes - handle in verify.logic.tsx
	ServerMessageCode.OTP_INVALID,
	ServerMessageCode.OTP_EXPIRED,
	ServerMessageCode.OTP_LOCKED,
	ServerMessageCode.OTP_RESEND_TOO_EARLY,
	ServerMessageCode.DM_TABLET_NAME_DUPLICATE,
];

export const MessageCodeToLogout: ServerMessageCode[] = [
	ServerMessageCode.IP_ADDRESS_PERMISSION_DENIED,
];

/** @description for translations */
export const alert16ReplaceText = (record: string | RoutesNameEnum) => {
	let text = record?.toLowerCase();
	switch (record) {
		case RoutesNameEnum.UM1_01:
			return text;
		case RoutesNameEnum.AM1_01:
			return text?.replace(' 조회', '');
		default:
			return text?.replace(' 관리', '')?.replace(' management', '');
	}
};

const textReplaceForAlert16 = (record: string | RoutesNameEnum) => {
	switch (record) {
		case RoutesNameEnum.UM1_01:
			return '';
		case RoutesNameEnum.AM1_01:
			return ' 조회';
		default:
			return ' 관리';
	}
};
/** @description there are no selected to delete */
export const Alert_16 = (record: string) =>
	`삭제할 ${record}를(을) 선택해주세요.`.replace(
		textReplaceForAlert16(record),
		''
	);

/** @description confirm to delete document */
export const Alert_17 = (record: string) =>
	`선택한 ${record}를 삭제 하시겠습니까?`;

/** @description There are duplicate default items or options. */
export const Alert_26 = (type: string) =>
	`${type}은 기본값과 중복되어 입력할 수 없습니다.`;

/** @description There are duplicate items or options. */
export const Alert_27 = (type: string) =>
	`중복된 ${type}을 입력할 수 없습니다.`;

export const Alert_2 = (gridName: string) => `${gridName}을(를) 선택해주세요.`;

/** @description limit file */
export const ALERT_38 = (limit: number) =>
	`첨부파일은 ${limit}개를 초과할 수 없습니다.`;

/** @description max file size */
export const ALERT_39 = (size: number) =>
	`첨부파일은 ${size}MB를 초과할 수 없습니다.`;

export const ALERT_41 = (address: string, name: string) =>
	`이미 제공자 정보가 있습니다. ${address} 숙소의 제공자 정보를 ${name}로 변경하시겠습니까?`;

export const ALERT_50 = (recommenderName: string, employerName: string) =>
	`이미 배우자 정보가 있습니다. ${recommenderName} 추천자의 배우자 정보를 ${employerName}로 변경하시겠습니까?`;

export const ALERT_62 = (applicantCount: number) =>
	`사업장과 ${applicantCount}명의 근로자 읍/면 정보가 다릅니다. 사업장의 읍/면 정보로 근로자 읍/면 정보를 변경하시겠습니까?`;

export const ALERT_78 = (fileNoAccept: string, isPreview: boolean) =>
	`'${fileNoAccept}' 의 파일 확장자는 지원하지 않아 \n 나머지 파일이 ${isPreview ? '미리보기' : '다운로드'} 됩니다.`;

export const ALERT_NO_DOCUMENTS_TO_PREVIEW_OR_DOWNLOAD = (isPreview: boolean) =>
	`${isPreview ? '미리보기할' : '다운로드할'} 서류가 없습니다.`;

export const ALERT_71 = (
	applicantAssignment: number,
	applicantPossible: number,
	gender: GenderLabelEnum
) =>
	`설정한 ${gender} 명 수(${applicantAssignment} 명) 보다 근무 가능한 ${gender} 근로자 수(${applicantPossible} 명)가 적습니다.`;

export const ALERT_71_PUBLIC = (
	applicantAssignment: number,
	applicantPossible: number,
	gender: GenderLabelEnum
) =>
	`입력하신 ${gender} 명 수(${applicantAssignment} 명) 보다 근무 가능한 ${gender} 근로자 수(${applicantPossible} 명)가 적습니다. 그대로 적용하시겠습니까?`;

export const ALERT_AM1_ASSIGN_NUM_OVER_REQUEST_NUM = (franchiseName: string) =>
	`${franchiseName}에 입력한 요청 인원보다 선택한 근로자가 많습니다.`;

export const CONFIRM_EXCEED_REQUEST_APPLICANT = (
	franchiseName: string,
	dates: string[]
) =>
	`'${franchiseName}' 사업장에 입력한 요청 인원보다 선택한 근로자가 많은 배정이 있습니다. 그대로 저장하시겠습니까?`;

export const CONFIRM_INSUFFICIENT_APPLICANTS = (
	franchiseName: string,
	dates: string[]
) =>
	`'${franchiseName}' 사업장에 입력한 요청 인원보다 선택한 근로자가 적은 배정이 있습니다. 그대로 저장하시겠습니까?`;

export enum WindowPostMessage {
	DELETE_SUCCESS = 'DELETE_SUCCESS',
	NEED_TO_RELOAD_LIST_AFTER_CLOSE_POPUP = 'NEED_TO_RELOAD_LIST_AFTER_CLOSE_POPUP',
	RELOAD_LIST_BUT_DO_NOT_CLOSE_POPUP = 'RELOAD_LIST_BUT_DO_NOT_CLOSE_POPUP',
	NEED_TO_CALLBACK_AFTER_CLOSE_POPUP = 'NEED_TO_CALLBACK_AFTER_CLOSE_POPUP',
}

export enum WindowPostActionType {
	RELOAD_PUBLIC_FRANCHISE_AGRICULTURE = 'RELOAD_PUBLIC_FRANCHISE_AGRICULTURE',
	RELOAD_PROGRAM_STATISTIC = 'RELOAD_PROGRAM_STATISTIC',
	RELOAD_HEADER_PROGRAM = 'RELOAD_HEADER_PROGRAM',
	RESET_HEADER_PROGRAM = 'RESET_HEADER_PROGRAM',
	RELOAD_INQUIRY_BOARD_ANSWER_AFTER_DELETE_ANSWER = 'RELOAD_INQUIRY_BOARD_ANSWER_AFTER_DELETE_ANSWER',
	RELOAD_ASSIGNMENT_CALENDAR = 'RELOAD_ASSIGNMENT_CALENDAR',
}
